import { iCheck, iEdit, iCamera, iImage, iMessageCircle } from '@hover/icons';
import { IHomeownerRenderingStep } from '../interfaces/IHomeownerRenderingStep';

export const HOMEOWNER_RENDERING_STEPS: IHomeownerRenderingStep[] = [
  {
    key: 0,
    icon: iCamera,
    body: 'Snap a photo',
  },
  {
    key: 1,
    icon: iMessageCircle,
    body: 'Tell us your style',
  },
  {
    key: 2,
    icon: iImage,
    body: 'Get your design',
  },
  {
    key: 3,
    icon: iEdit,
    body: 'Revise and tweak',
  },
  {
    key: 4,
    icon: iCheck,
    body: 'Take the next step',
  },
];
